/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { styles } from '#PRIVATE_Chart/themes/ChartStyles.css';
import { VNode } from 'preact';
import { classNames } from '#utils/UNSAFE_classNames';
import { VisLabelStyle } from '#utils/UNSAFE_visTypes/common/textTypes';
import { updateVisTextStyleProperties } from '#utils/UNSAFE_visUtils/textUtils';
import { Dimension } from '#utils/UNSAFE_visTypes/common';
import { Font } from '#hooks/PRIVATE_useTextDimensions';
import { getLabelPosition } from '#utils/PRIVATE_chartUtils/utils';

const DEFAULT_POSITION = 'center';

type Props = {
  labelPosition?: 'belowMarker' | 'aboveMarker' | 'beforeMarker' | 'afterMarker' | 'center';
  label?: string;
  labelStyle?: VisLabelStyle;
  tx?: number;
  ty?: number;
  defaultFontSize: string;
  dataLabelEffect: 'outline' | 'none';
  isHighContrast: boolean;
  getTextDimensions?: (text: string, style: Font) => Dimension;
  isRtl: boolean;
};

export function MarkerLabel({
  labelPosition,
  label,
  labelStyle,
  tx,
  ty,
  defaultFontSize,
  dataLabelEffect,
  isHighContrast,
  getTextDimensions,
  isRtl
}: Props) {
  let markerLabel: VNode | null = null;
  const position = labelPosition ? labelPosition : DEFAULT_POSITION;
  const { dataLabelStyle, dataLabelContrast, highContrastLabelStyle } = styles;
  const labelString = label;

  if (position && labelString) {
    const markerLabelStyle = {
      fontSize: defaultFontSize,
      ...updateVisTextStyleProperties(labelStyle)
    };

    const labelDims = getTextDimensions?.(labelString, markerLabelStyle);
    const { x, y } = getLabelPosition(position, tx, ty, labelDims, isRtl);
    markerLabel = (
      <text
        x={x}
        y={y}
        class={classNames([
          dataLabelStyle,
          dataLabelEffect === 'outline' ? dataLabelContrast : '',
          isHighContrast ? highContrastLabelStyle : ''
        ])}
        style={markerLabelStyle}>
        {labelString}
      </text>
    );
  }
  return markerLabel;
}
